import React from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import ColorContent from './ColorContent';

export default function CasinoColor() {
  return (
    <CasinoContainer title={'Colors casino'}>
      <ColorContent />
    </CasinoContainer>
  );
}
